<template>
  <!-- :bodyStyle="{paddingTop:'0px'}" :headStyle="{borderBottom:'0px'}" -->
  <a-card :bordered="false" title="订单列表" :bodyStyle="{paddingTop:'0px'}"
          :headStyle="{borderBottom:'0px',fontSize:'18px'}">
    <a-form>
      <search-header :col="3">
        <search-list>
          <a-form-item label="订单编号" v-bind="searchItemLayout">
            <a-input v-model="queryParams.orderNo" placeholder="请输入"></a-input>
          </a-form-item>
          <a-form-item label="订单状态" v-bind="searchItemLayout">
            <a-select
              style="width: 100%"
              v-model="queryParams.orderState"
              placeholder="请选择" allowClear
            >
              <a-select-option value>全部</a-select-option>
              <a-select-option v-for="item in orderStateList" :key="item.code" :value="item.code">{{ item.name }}
              </a-select-option>
            </a-select>
          </a-form-item>
          <a-form-item label="支付状态" v-bind="searchItemLayout">
            <a-select style="width: 100%" allowClear v-model="queryParams.orderPayState" placeholder="请选择">
              <a-select-option v-for="item in payStateList" :key="item.code" :value="item.code">{{ item.name }}
              </a-select-option>
            </a-select>
          </a-form-item>
        </search-list>
        <search-list>
          <a-form-item label="第三方订单号" v-bind="searchItemLayout">
            <a-input v-model="queryParams.orderThirdOrderNo" placeholder="请输入"></a-input>
          </a-form-item>
          <a-form-item label="商品信息" v-bind="searchItemLayout">
            <a-input v-model="queryParams.orderProName" placeholder="请输入商品名称、商品ID"></a-input>
          </a-form-item>
          <a-form-item label="联系人姓名" v-bind="searchItemLayout">
            <a-input v-model="queryParams.orderContact" placeholder="请输入"></a-input>
          </a-form-item>
        </search-list>
        <search-list>
          <a-form-item label="联系人手机" v-bind="searchItemLayout">
            <a-input v-model="queryParams.orderContactMobile" placeholder="请输入"></a-input>
          </a-form-item>
          <a-form-item label="供应商" v-bind="searchItemLayout">
            <a-input v-model="queryParams.orderProSupply" placeholder="简称/全称/手机号"></a-input>
          </a-form-item>
          <a-form-item label="分销商" v-bind="searchItemLayout">
            <a-input v-model="queryParams.orderProDistribution" placeholder="简称/全称/手机号"></a-input>
          </a-form-item>
        </search-list>
        <search-list>
          <a-form-item label="销售员" v-bind="searchItemLayout">
            <a-input v-model="queryParams.orderStaff" placeholder="姓名/手机号"></a-input>
          </a-form-item>
          <a-form-item label="来源用户" v-bind="searchItemLayout">
            <a-input v-model="queryParams.orderMember" placeholder="昵称/手机号"></a-input>
          </a-form-item>
          <a-form-item label="订单类型" v-bind="searchItemLayout">
            <a-select
              style="width: 100%"
              v-model="queryParams.orderProType"
              placeholder="请选择" allowClear
            >
              <a-select-option v-for="item in proCataLogIdList" :key="item.code" :value="item.code">{{ item.name }}
              </a-select-option>
            </a-select>
          </a-form-item>
        </search-list>
      </search-header>
      <a-row>
        <a-col v-if="showOrderTravelTime" :span="8">
          <a-form-item label="出游日期" v-bind="searchItemLayout">
            <a-range-picker @change="onDateChange" :value="selectedDate" style="width: 100%"/>
          </a-form-item>
        </a-col>
        <a-col :span="8">
          <a-form-item label="下单时间" v-bind="searchItemLayout">
            <a-select
              style="width: 38%;margin-right:2%;"
              v-model="orderDay"
              placeholder="请选择"
              @change="onChangeOrderDay"
            >
              <a-select-option v-for="item in dateAllList" :key="item.code" :value="item.code">{{ item.name }}
              </a-select-option>
            </a-select>
            <a-range-picker
              :disabledDate="disabledDate"
              @calendarChange="onCalendarChange"
              format="YYYY-MM-DD"
              @change="onOrderDateChange"
              :value="orderDate"
              style="width: 60%"/>
          </a-form-item>
        </a-col>
        <a-col :span="8">
          <a-form-item style="margin-left: 4%">
            <a-button type="primary" @click="searchBtn">查询</a-button>
            <a-button @click="exportData">批量导出</a-button>
            <a-button @click="handleLook">查看已生成报表</a-button>
          </a-form-item>
        </a-col>
      </a-row>
      <a-form-item>
        <a-radio-group v-model="queryParams.orderState" @change="onOrderChange">
          <a-radio-button value>全部</a-radio-button>
          <a-radio-button :value="1">待确认</a-radio-button>
          <template v-if="showProductState">
            <a-radio-button :value="10">待发货</a-radio-button>
            <a-radio-button :value="12">待收货</a-radio-button>
            <a-radio-button :value="13">已收货</a-radio-button>
          </template>
          <a-radio-button :value="11">退款中</a-radio-button>
          <a-radio-button :value="3">已关闭</a-radio-button>
        </a-radio-group>
      </a-form-item>
    </a-form>
    <custom-page-table
      ref="table"
      rowKey="orderNo"
      :columns="columns"
      :queryParams="queryParams"
      :requestPromise="loadPromise"
    >
      <div slot="proSlots" slot-scope="data" class="name-box" @click="onPreview(data.record)">
        <a-tooltip placement="topLeft">
          <template slot="title">{{ data.text }}</template>
          <div class="pro_name">{{ data.text }}</div>
        </a-tooltip>
        <div v-if="data.record.orderOptionName">
          <span v-if="data.record.orderProType==1">票型：</span>
          <span v-else-if="data.record.orderProType==2">房型：</span>
          <span v-else>套餐：</span>
          {{ data.record.orderOptionName }}
        </div>
      </div>
      <span class="price-class" slot="aiPlatformOrderFlag"
            slot-scope="data">{{ data.text === true ? 'AI旅链' : '自营' }}</span>
      <p class="p" slot="orderDistributorRemarks" slot-scope="data">{{ getRemarkText(data.text) }}</p>
      <span class="price-class" slot="priceSlots" slot-scope="data">￥{{ data.text }}</span>
      <template slot="contactSlots" slot-scope="data"><span v-html="getContactsSplit(data.text)"></span></template>
      <div slot="action" slot-scope="data">
        <a @click="toDetail(data.record)">订单详情</a>
        <span
          v-if="((data.record.orderPayState==1&&data.record.orderState==1)||data.record.orderState>=4&&data.record.orderState<=7)&&data.record.orderProSupplierId==merchantId">
        <a-divider type="vertical"/>
        <a @click="toDetail(data.record)">处理订单</a>
      </span>
      </div>
    </custom-page-table>
    <!-- 导出弹窗 -->
    <ExportTableData v-if="visiblePopup" :queryParams="queryParams" :isCustom="true" :exportReportType="1"
                     :visiblePopup="visiblePopup" @childCloseDialog="closeDialog"></ExportTableData>
  </a-card>
</template>

<script>
import { addDate, formatFullDate, isYearLeap, getNumberOfDays } from '@/utils/common.js'
import ExportTableData from '@/customComponents/exportTableData/exportTableData'
import searchForm from '@/utils/mixins/searchFormMixins'
import moment from 'moment'
import { mapState } from 'vuex'
import RouterSwitchHelper from '@/utils/helper/RouterSwitchHelper'

export default {
  name: 'OrderList',
  mixins: [searchForm],
  components: {
    ExportTableData
  },
  data() {
    return {
      moment,
      selectedDate: undefined,
      visiblePopup: false,
      orderDate: this.getDateHelper().getDateMoments(addDate(new Date(), -90), new Date()),
      orderDay: -90,
      payStateList: [],
      orderStateList: [],
      proCataLogIdList: [],
      merchantId: this.$store.getters.userInfo.merchantId,
      queryParams: {
        orderState: 1,
        orderCreateTimeStart: addDate(new Date(), -90),
        orderCreateTimeEnd: formatFullDate(new Date(), true)
      },
      dateAllList: [
        { name: '最近90天内', code: -90 },
        { name: '最近30天内', code: -30 },
        { name: '自定义', code: -365 }
      ],
      loadPromise: params => this.getOrderListPromise(params),
      columns: [
        {
          title: '订单编号',
          dataIndex: 'orderNo',
          width: '200px'
        },
        {
          title: '商品信息',
          dataIndex: 'orderProName',
          scopedSlots: { customRender: 'proSlots' },
          width: '420px'
        },
        {
          title: '数量',
          dataIndex: 'orderPayNum',
          width: '120px'
        },
        {
          title: '来源',
          dataIndex: 'aiPlatformOrderFlag',
          scopedSlots: { customRender: 'aiPlatformOrderFlag' },
          width: '100px'
        },
        {
          title: '订单金额',
          dataIndex: 'orderAmt',
          scopedSlots: { customRender: 'priceSlots' },
          width: '120px'
        },
        {
          title: '联系人',
          dataIndex: 'orderContact',
          width: '120px',
          scopedSlots: { customRender: 'contactSlots' }
        },
        {
          title: '出游/游玩日期',
          dataIndex: 'orderTravelDate',
          width: '260px'
        },
        {
          title: '下单时间',
          dataIndex: 'orderCreateTime',
          width: '180px'
        },
        {
          title: '备注',
          dataIndex: 'orderDistributorRemarks',
          scopedSlots: { customRender: 'orderDistributorRemarks' },
          width: '280px'
        },
        {
          title: '操作',
          dataIndex: 'action',
          width: '165px',
          fixed: 'right',
          scopedSlots: { customRender: 'action' },
          fixed: 'right'
        }
      ],
      formItemLayoutBtns: {
        labelCol: {
          xxl: { span: 4 },
          xl: { span: 4 },
          lg: { span: 5 },
          sm: { span: 5 },
          md: { span: 5 },
          xs: { span: 12 }
        },
        wrapperCol: {
          xxl: { span: 16 },//≥1600px 响应式栅格，可为栅格数或一个包含其他属性的对象
          xl: { span: 20 },//≥1200px 响应式栅格，可为栅格数或一个包含其他属性的对象
          lg: { span: 19 },//≥992px 响应式栅格，可为栅格数或一个包含其他属性的对象
          sm: { span: 19 },//≥768px 响应式栅格，可为栅格数或一个包含其他属性的对象
          md: { span: 19 },//≥576px 响应式栅格，可为栅格数或一个包含其他属性的对象
          xs: { span: 12 }//xs	<576px 响应式栅格，可为栅格数或一个包含其他属性的对象
        }
      },
      selectedDateTime: '',
      disabledDate: current => {
        return current._d.getTime() > new Date(this.selectedDateTime).getTime() + 8.64e7 * 365
      },
      showOrderTravelTime: false, // 显示出游日期
      showProductState: false // 显示待发货/待收货/已收货
    }
  },
  computed: {
    ...mapState({
      versionLimit: state => state.user.versionInfo.versionLimit
    })
  },
  mounted() {
    this.getOrderStateList()
    this.getProCataLogId()
    this.getPayStateList()
    this.getMerchantNewField() //  获取商户新特性[类型&可售卖产品]
  },
  activated() {
    this.getLogUtils().logWithTag('==版本是否过期==', this.versionLimit)
    let orderState = this.$route.query.orderState
    if (orderState) {
      this.getLogUtils().logWithTag('activated', '第一次进来')
      if (orderState == 100) {
        this.queryParams.orderState = ''
      } else {
        this.queryParams.orderState = Number(orderState)
      }
      this.$refs.table.refresh(true)
    }
  },
  methods: {
    getRemarkText(list) {
      if (list && Array.isArray(list) && list.length > 0) {
        return list.filter(str => !!str).join('\n')
      }
      return ''
    },
    // 获取订单状态
    getOrderStateList() {
      this.getHttpServices().getOrderService().get('order/getOrderStateList')
        .then(res => {
          this.getLogUtils().logWithTag('==getOrderStateList==', res)
          this.orderStateList = res
        }).catch(reason => this.showNetWorkErrorMessage(reason))
    },
    // 获取支付状态
    getPayStateList() {
      this.getHttpServices().getBaseService().get('base/sysCode/getPayStateList')
        .then(res => {
          this.getLogUtils().logWithTag('==getPayStateList==', res)
          this.payStateList = res
        }).catch(reason => this.showNetWorkErrorMessage(reason))
    },
    // 获取商品状态
    getProCataLogId() {
      this.getHttpServices().getProService().get('product/info/getProCataLogId')
        .then(res => {
          this.getLogUtils().logWithTag('==getPayStateList==', res)
          this.proCataLogIdList = res
        }).catch(reason => this.showNetWorkErrorMessage(reason))
    },
    // 获取表格数据接口
    getOrderListPromise(params) {
      this.getLogUtils().logWithTag('==getOrderListPromise==', params)
      return this.getHttpServices().getOrderService().post('api/v2/orderManage/findOrderList', params)
    },
    //日期变更
    onDateChange(dates, dateStrArr) {
      this.selectedDate = dates
      this.queryParams.orderTravelTimeStart = dateStrArr[0]//出游开始日期
      this.queryParams.orderTravelTimeEnd = dateStrArr[1]//出游结束日期
    },
    // 下单日期
    onOrderDateChange(dates, dateStrArr, flag) {
      this.orderDate = dates
      this.queryParams.orderCreateTimeStart = dateStrArr[0]//下单开始日期
      this.queryParams.orderCreateTimeEnd = dateStrArr[1]//下单结束日期
      if (!flag) {
        this.orderDay = -365
      }
    },
    searchBtn() {
      let isDayNum = getNumberOfDays(this.queryParams.orderCreateTimeStart, this.queryParams.orderCreateTimeEnd)
      if ((isDayNum - 365) > 0) {
        this.$message.error('下单时间查询最大范围365天')
      } else {
        this.$refs.table.refresh(true)
      }
    },
    onChangeOrderDay(value) {
      this.orderDay = value
      this.queryParams.orderCreateTimeStart = addDate(new Date(), this.orderDay)//下单开始日期
      this.queryParams.orderCreateTimeEnd = formatFullDate(new Date(), true)//下单结束日期
      let dateStrArr = [this.queryParams.orderCreateTimeStart, this.queryParams.orderCreateTimeEnd]
      let dates = this.getDateHelper().getDateMoments(this.queryParams.orderCreateTimeStart, this.queryParams.orderCreateTimeEnd)
      this.onOrderDateChange(dates, dateStrArr, true)
    },
    onOrderChange(e) {
      this.getLogUtils().logWithTag('e.target.value', e.target.value)
      this.queryParams.orderState = e.target.value
      this.$refs.table.refresh(true)
    },
    toDetail(record) {
      // this.getLogUtils().logWithTag("record==",record);
      this.$router.push({
        name: 'OrderDetails',
        query: {
          orderNo: record.orderNo
        }
      })
    },
    // 关闭导出弹窗
    closeDialog() {
      this.visiblePopup = false
    },
    // 订单导出
    exportData() {
      this.visiblePopup = true
      // if(this.versionLimit==1){
      //   this.visiblePopup = true;
      // }else{
      //   this.$message.error("您的版本已经过期，请续费或升级版本后操作！")
      //   this.goVersionUpdate();
      // }
    },
    // 查看已生产报表
    handleLook() {
      this.$router.push({
        name: 'DownloadTable'
      })
      // if(this.versionLimit==1){
      //   this.$router.push({
      //     name:"DownloadTable"
      //   })
      // }else{
      //   this.$message.error("您的版本已经过期，请续费或升级版本后操作")
      //   this.goVersionUpdate();
      // }
    },
    getContactsSplit(txt) {
      if (txt) {
        return txt.replace(',', '<br/>')
      } else {
        return ''
      }
    },
    onCalendarChange(dates, dateStrings) {
      this.getLogUtils().logWithTag('onCalendarChange', dates)
      this.getLogUtils().logWithTag('onCalendarChange', dateStrings)
      this.selectedDateTime = dates[0]._d
      this.getLogUtils().logWithTag(this.selectedDateTime)
    },
    // 版本升级页面
    goVersionUpdate() {
      setTimeout(() => {
        this.$router.push({
          name: 'VersionDescription'
        })
      }, 1000)
    },
    onPreview(record) {
      if (record.orderProType == 6 || record.orderProType == 7 || record.orderProType == 83) {
        return
      }
      const character = 1
      const params = {
        p: `${character}_${record.orderProSupplierId}_${record.orderProSupplierId}`
      }
      let domainUrl = this.$store.getters.platformConfig.h5Url
      RouterSwitchHelper.toProductDetails(domainUrl, record.orderProId, record.orderProType, 0, params)
    },
    getMerchantNewField() {
      this.getHttpServices().getApiService().post('homeMerchant/getMerchantNewField/' + this.merchantId)
        .then(res => {
          if (res.productCatalogList && res.productCatalogList.length) {
            // 1门票 2酒店 3签证 4景酒 5 百货 8抢购 73出境跟团 74国内跟团 75自由行
            this.showOrderTravelTime = res.productCatalogList.some(item => item === 2 || item === 1 || item === 74 || item === 74 || item === 75) // 酒店，门票，国内跟团、出境跟团、自由行品类显示
            this.showProductState = res.productCatalogList.some(item => item === 5 || item === 8) // 待发货、待收货、已收货 三个状态为百货、抢购 分类使用
          }
        }).catch(reason => this.showNetWorkErrorMessage(reason))
    }
  }

}
</script>
<style lang="less" scoped>
.ant-btn + .ant-btn {
  margin-left: 10px;
}

.ant-card-body {
  background-color: #ececec !important;
}

.from-class {
  background: #ECECEC;
  padding-top: 24px;
  padding-right: 10px;
}

.price-class {
  color: #fea834;
}

.a-btns {
  margin-right: 5px;
}

.pro_name {
  width: 100%;
  overflow: hidden;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  -ms-text-overflow: ellipsis;
  text-overflow: ellipsis;
}

.name-box {
  cursor: pointer;
}

.p {
  white-space: pre-wrap;
  margin: 0;
}
</style>